
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { MediaInputValue } from "@/types/media";
import IconInput from "@/components/Reusable/CustomInputs/IconInput/IconInput.vue";
import { documentStore, singularityStore } from "@/store/store";
import { findNode } from "@/lib/tree/tree";
import lodash from "lodash";
import SingularityPanelHeader from "@/components/Singularity/PanelHeader/SingularityPanelHeader.vue";

@Component({
  components: {
    IconInput,
    SingularityPanelHeader
  }
})
export default class IconEditor extends Vue {
  get iconId() {
    return singularityStore.iconEditorPanelState.iconId;
  }

  get iconInputValue() {
    if (!this.iconId) return null;

    const node = findNode(documentStore.document.tree, this.iconId);

    if (!node) return null;

    const result = lodash.get(node.data.properties, PATH_TO_ICON_INPUT);

    if (!result) return null;

    return result;
  }

  updateIconInputValue(value: MediaInputValue) {
    if (!this.iconId) return;

    documentStore.unthrottledPropertyChanged({
      elementId: this.iconId,
      path: PATH_TO_ICON_INPUT,
      value: value,
      meta: {
        snapshotLabel: "Icon Editor Input Update"
      }
    });
  }
}

const PATH_TO_ICON_INPUT = "content.content.icon";
